const BR_TAG = /<br\s*\/?>/gi;
const BR_ONLY = /^\s*<br\s*\/?>\s*$/i;

/**
 * Normalize Milkdown markdown for Platform / restore compatibility.
 *
 * Milkdown empty paragraphs serialize as HTML `<br />`. In GFM table rows:
 * - cell that is only `<br />` → empty (empty-paragraph marker)
 * - embedded `<br />` → Platform `\n` hard-break escape (do not drop)
 *
 * Outside tables, `<br />` becomes `\n`.
 */
export function normalizeMarkdown(md: string): string {
  const withoutTableBr = md.replace(/^[ \t]*\|.*\|[ \t]*$/gm, (row) => {
    const parts = row.split('|');
    if (parts.length < 3) {
      return row;
    }

    const cells = parts.slice(1, -1).map((cell) => {
      if (BR_ONLY.test(cell)) {
        return cell.replace(BR_TAG, '');
      }

      return cell.replace(BR_TAG, '\\n');
    });

    return `${parts[0]}|${cells.join('|')}|${parts[parts.length - 1]}`;
  });

  return withoutTableBr.replace(/<br\s*\/?>\n?/gi, '\n');
}
